// import React from "react";
// import { Button } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";

// const AddItemBtn = ({ label, onClick }) => (
//   <Button
//     variant="outlined"
//     startIcon={<AddIcon />}
//     onClick={onClick}
//     fullWidth
//     sx={{
//       borderStyle: "dashed",
//       borderRadius: "8px",
//       textTransform: "none",
//       mt: 1,
//       color: "text.secondary",
//       "&:hover": {
//         borderStyle: "dashed",
//         color: "#3b82f6",
//         borderColor: "#3b82f6",
//       },
//     }}
//   >
//     {label}
//   </Button>
// );

// export default AddItemBtn;


import React from "react";
import { Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const AddItemBtn = ({ label, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.75,
      mt: 1.5,
      py: 1.25,
      borderRadius: "8px",
      border: "1.5px dashed rgba(255,255,255,0.15)",
      cursor: "pointer",
      transition: "all 0.18s ease",
      background: "transparent",
      "&:hover": {
        border: "1.5px dashed #3b82f6",
        background: "rgba(59,130,246,0.05)",
        "& .add-label": { color: "#3b82f6" },
        "& .add-icon": { color: "#3b82f6" },
      },
    }}
  >
    <AddIcon
      className="add-icon"
      sx={{ fontSize: 15, color: "rgba(255,255,255,0.3)", transition: "color 0.18s" }}
    />
    <Typography
      className="add-label"
      variant="caption"
      fontWeight={500}
      sx={{ color: "rgba(255,255,255,0.35)", transition: "color 0.18s" }}
    >
      {label}
    </Typography>
  </Box>
);

export default AddItemBtn;